import classNames from "classnames/bind";
import * as React from "react";
import { TextareaAutosizeProps } from "react-textarea-autosize";
import { withValidation } from "../../sharedHOC/withValidation/withValidation";
import { blockForFullStory } from "../../utils/blockForFullStory";
import { AutosizeTextArea } from "./AutoSizeTextArea";
import { GenericInput, ThemedInputProps } from "./Input";
import * as styles from "./TextArea.less";

const classNamesCtx = classNames.bind(styles);

export enum textareaTheme {
    name = "name",
    description = "description",
    details_input = "details_input",
    simple = "simple",
    table_editor = "table_editor",
    naked = "naked",
}

export const defaultNonInlineTextAreaTheme: Pick<ThemedInputProps<textareaTheme>, "theme"> = {
    theme: textareaTheme.simple,
};

export type TextAreaProps = ThemedInputProps<textareaTheme> & {
    isAutoResize?: boolean;
    autoSizeOptions?: Partial<Omit<TextareaAutosizeProps, "ref">>;
    className?: string;
} & Pick<React.TextareaHTMLAttributes<HTMLTextAreaElement>, "rows">;

export class TextArea extends GenericInput<TextAreaProps, HTMLTextAreaElement> {
    render() {
        let { theme = [] } = this.props;
        const {
            value,
            disabled,
            readonly,
            placeholder = "",
            showValidation,
            autoComplete = "off",
            maxLength = null,
            className,
            rows,
        } = this.props;

        if (typeof theme === "string") {
            theme = [theme];
        }

        const themeClassNames = theme.map(t => styles[t]);

        const textArea = (
            <>
                {this.renderTextArea({
                    className: blockForFullStory(
                        classNamesCtx(styles.textarea, className, themeClassNames, { error: showValidation }),
                        this.props
                    ),
                    disabled: disabled || false,
                    readOnly: readonly || false,
                    value: value || "",
                    onChange: this.onChange,
                    placeholder,
                    onBlur: this.onBlur,
                    onClick: this.onClick,
                    onFocus: this.onFocus,
                    onPaste: this.onPaste,
                    autoComplete,
                    maxLength,
                    rows,
                    "aria-label": this.props["aria-label"],
                })}
                {this.renderIcon()}
            </>
        );

        return this.renderWithLabel(textArea);
    }

    renderTextArea(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
        const { isAutoResize, autoSizeOptions } = this.props;

        return isAutoResize ? (
            <AutosizeTextArea {...props} {...autoSizeOptions} inputRef={this.inputRef} />
        ) : (
            <textarea {...props} ref={this.inputRef} />
        );
    }
}

export const TextAreaWithValidation = withValidation(TextArea);
